import React from 'react';
import { motion } from 'framer-motion';
import './Services.css';
import { servicesData } from '../../data/servicesData';
import { BsCheck2Circle } from 'react-icons/bs';

const Services = () => {
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.12, delayChildren: 0.15 }
    }
  };

  const card = {
    hidden: { opacity: 0, y: 48 },
    show: {
      opacity: 1,
      y: 0,
      transition: { type: 'spring', stiffness: 220, damping: 24 }
    }
  };

  const spring = { type: 'spring', stiffness: 320, damping: 22 };

  return (
    <section id={servicesData.header.id} className="services-section">
      <motion.h5
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        {servicesData.header.subtitle}
      </motion.h5>
      <motion.h2
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.08 }}
      >
        {servicesData.header.title}
      </motion.h2>

      <div className="container servicesContainer">
        <motion.div
          className="servicesGrid"
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: '-50px' }}
        >
          {servicesData.services.map((service, serviceIndex) => (
            <motion.div
              key={serviceIndex}
              className="serviceCard"
              variants={card}
              whileHover={{
                y: -12,
                scale: 1.02,
                transition: spring
              }}
              whileTap={{ scale: 0.99 }}
            >
              <motion.div
                className="serviceHead"
                whileHover={{ scale: 1.02 }}
                transition={spring}
              >
                <h3>{service.title}</h3>
              </motion.div>
              <ul className="serviceList">
                {service.items.map((item, itemIndex) => (
                  <motion.li
                    key={itemIndex}
                    className={item.className}
                    initial={{ opacity: 0, x: -8 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.2 + itemIndex * 0.04 }}
                  >
                    <BsCheck2Circle className="listIcon" />
                    <p>{item.text}</p>
                  </motion.li>
                ))}
              </ul>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Services;
